// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".publisher-counters__wrapper li[data-v-416aaba5]{line-height:18px;font-weight:600;font-size:16px}@media (max-width:767px){.publisher-counters__wrapper li[data-v-416aaba5]{font-size:13px}}", ""]);
// Exports
module.exports = exports;
